// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file upload/upload_requests.proto (package com.gem.bff.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

/**
 * Describes the file upload/upload_requests.proto.
 */
export const file_upload_upload_requests: GenFile =
  /*@__PURE__*/
  fileDesc(
    'Chx1cGxvYWQvdXBsb2FkX3JlcXVlc3RzLnByb3RvEhRjb20uZ2VtLmJmZi5jb250cmFjdCJBChhHZW5lcmF0ZVVwbG9hZFVybFJlcXVlc3QSEAoIZmlsZW5hbWUYASABKAkSEwoLY29udGVudFR5cGUYAiABKAkiRAoYR2V0U3RvcmFnZVNlc3Npb25SZXF1ZXN0EhgKC2FjY2Vzc1Rva2VuGAEgASgJSACIAQFCDgoMX2FjY2Vzc1Rva2VuQhgKFGNvbS5nZW0uYmZmLmNvbnRyYWN0UAFiBnByb3RvMw'
  );

/**
 * @generated from message com.gem.bff.contract.GenerateUploadUrlRequest
 */
export type GenerateUploadUrlRequest = Message<'com.gem.bff.contract.GenerateUploadUrlRequest'> & {
  /**
   * @generated from field: string filename = 1;
   */
  filename: string;

  /**
   * @generated from field: string contentType = 2;
   */
  contentType: string;
};

/**
 * Describes the message com.gem.bff.contract.GenerateUploadUrlRequest.
 * Use `create(GenerateUploadUrlRequestSchema)` to create a new message.
 */
export const GenerateUploadUrlRequestSchema: GenMessage<GenerateUploadUrlRequest> =
  /*@__PURE__*/
  messageDesc(file_upload_upload_requests, 0);

/**
 * @generated from message com.gem.bff.contract.GetStorageSessionRequest
 */
export type GetStorageSessionRequest = Message<'com.gem.bff.contract.GetStorageSessionRequest'> & {
  /**
   * @generated from field: optional string accessToken = 1;
   */
  accessToken?: string;
};

/**
 * Describes the message com.gem.bff.contract.GetStorageSessionRequest.
 * Use `create(GetStorageSessionRequestSchema)` to create a new message.
 */
export const GetStorageSessionRequestSchema: GenMessage<GetStorageSessionRequest> =
  /*@__PURE__*/
  messageDesc(file_upload_upload_requests, 1);
